module.exports = __webpack_public_path__ + "img/lu.06956a13.svg";